import { HttpClientCall } from '@root/src/lib/HttpClient';

export const postOrder = async orderData => {
  const httpClient = new HttpClientCall();
  const response = await httpClient.httpPost('/order', orderData);
  return response;
};

export async function getOrderDetails(orderCode: string | number) {
  try {
    const httpClient = new HttpClientCall();
    const data = await httpClient.httpGet(
      `/order/get-product-in-order/${encodeURIComponent(String(orderCode))}`
    );
    return data;
  } catch (error) {
    console.error('Error fetching product by ID:', error);
    return null;
  }
}

export async function getListOrderCustomer(phone: string) {
  try {
    const httpClient = new HttpClientCall();
    const listOrder = httpClient.httpGet(`/order/getListOrderByPhone/${phone}`);
    return listOrder;
  } catch (error) {
    console.log("Phone didn't exist");
    return null;
  }
}

export async function createInventoryTransactions(data: any) {
  try {
    const httpClient = new HttpClientCall();
    const response = await httpClient.httpPost(`/warehouse/inventory`, data);
    return response;
  } catch (error) {
    console.log('Error creating inventory transactions:', error);
    return null;
  }
}
